(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_medidas_dispositivo"] && !Shopify.designMode) return;
  try {
    class MedidasDispositivoHandler {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.input = wrapper.querySelector('.medidas-dispositivo__input');
      this.errorEl = wrapper.querySelector('[data-medidas-error]');
      this.required = wrapper.dataset.required === 'true';

      if (!this.input) return;

      const formId = this.input.getAttribute('form');
      this.form = formId ? document.getElementById(formId) : this.input.closest('form');
      if (!(this.form instanceof HTMLFormElement)) return;

      this.input.addEventListener('input', () => this.validate());
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      this.validate();
    }

    isValid() {
      if (!this.required) return true;
      return this.input.value.trim().length > 0;
    }

    validate() {
      const valid = this.isValid();
      this.toggleAddToCart(!valid);
      if (valid) this.clearError();
      return valid;
    }

    handleSubmit(event) {
      if (!this.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.showError();
        this.input.focus();
      }
    }

    showError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = this.wrapper.dataset.errorMessage || 'Indica las medidas de tu dispositivo.';
      this.errorEl.classList.remove('hidden');
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.classList.add('hidden');
    }

    toggleAddToCart(disabled) {
      const button = this.form.querySelector('button[name="add"]');
      if (!(button instanceof HTMLButtonElement)) return;

      if (disabled) {
        button.disabled = true;
        button.dataset.medidasDisabled = 'true';
        return;
      }

      delete button.dataset.medidasDisabled;
      if (!button.dataset.personalizadorDisabled && !button.dataset.joyaDisabled) {
        button.disabled = false;
      }
    }
  }

  function initMedidasDispositivo(root) {
    (root || document).querySelectorAll('.medidas-dispositivo').forEach((wrapper) => {
      if (wrapper.dataset.medidasInit === 'true') return;
      wrapper.dataset.medidasInit = 'true';
      new MedidasDispositivoHandler(wrapper);
    });
  }

  initMedidasDispositivo();
  document.addEventListener('shopify:section:load', (event) => initMedidasDispositivo(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    const stickyFilterBars = document.querySelectorAll('.facets-toggle--sticky');

  const updateStickyFilterBars = () => {
    stickyFilterBars.forEach((bar) => {
      const top = Number.parseFloat(getComputedStyle(bar).top) || 0;
      const isStuck = bar.getBoundingClientRect().top <= top + 1;
      bar.dataset.stuck = isStuck ? 'true' : 'false';
    });
  };

  if (stickyFilterBars.length) {
    let ticking = false;

    const requestStickyFilterBarUpdate = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        updateStickyFilterBars();
        ticking = false;
      });
    };

    updateStickyFilterBars();
    window.addEventListener('scroll', requestStickyFilterBarUpdate, { passive: true });
    window.addEventListener('resize', requestStickyFilterBarUpdate);
  }
  } catch(e) { console.error(e); }
})();

})();
